'use strict';

var SiteConstants = require('../../../bc_sheplersbootbarn_core/cartridge/js/SiteConstants');
var util = require('./util');

var siteName;
var $win = $(window);
var getSuggestionsHttpRequest;
var getSuggestionsTimer;
var getSuggestionsLastQuery;

/**
     * @function
     * @description Configures parameters and required object instances
     */
function init() {
    siteName = window.pageContext.site || '';

    $('.top-banner .header-search button[type="submit"]').on('click', function(event) {
        event.preventDefault();

        var $this = $(this);
        var $searchForm = $this.closest('form');
        var $searchInput = $searchForm.find('[name="q"]');
        var action = $searchForm.attr('action');
        var keyword = $searchInput.val();
        var url = action + "?q=" + keyword;

        if (keyword && keyword != $searchInput.attr('placeholder')) {
            $searchForm.attr('action', url);
            $searchForm.submit();
        }
    });
	$('.header-search').on('click.SearchClear', 'button[type="reset"]', function(event) {
		event.preventDefault();
		$('.header-search').attr('has-value', 'false');
		$('.header-search input#q, .header-search input#mobile-q').val('');
		$('.header-search input#q:visible, .header-search input#mobile-q:visible').focus();
	});
	$('.top-banner-bar .scan').on('click.SearchClear', 'button[type="reset"]', function(event) {
		event.preventDefault();
		$('.top-banner-bar .scan').attr('has-value', 'false');
		$('.top-banner-bar .scan .search-input').val('').focus();
	});
	$(document).on('focus click keyup', '.header-search input#q, .header-search input#mobile-q', function(event) {
		var $this = $(this);
		var keyword = $this.val();
		$('.header-search').attr('has-value', !!(keyword && keyword.length > 1 && keyword != $this.attr('placeholder')));
		if ((SitePreferences.SEARCH_SUGGESTIONS_ENABLED || (SitePreferences.CIMULATE_ENABLED && SitePreferences.CIMULATE_SEARCH_SUGGESTIONS_ENABLED)) && keyword && keyword.length > 1 && keyword != $this.attr('placeholder')) {
			if (getSuggestionsTimer) {
				clearTimeout(getSuggestionsTimer);
			}
			if (keyword == getSuggestionsLastQuery) {
				renderSuggestions().catch(promotedSuggestions);
			} else {
				getSuggestionsTimer = setTimeout(function() {
					getSuggestions($this.val()).then(renderSuggestions).catch(promotedSuggestions);
				}, 250);
			}
		} else if (SitePreferences.PROMOTED_SEARCHES) {
			promotedSuggestions();
		}
	});


    if (siteName == SiteConstants.SiteIds.BootBarnUS) {
        $('.header-search').on('click.SearchActive', function() {
            $('.header-search').addClass('active');
        });

        $('.header-search input#q').on('focusout', function() {
			if (!$(this).val()) {
            	$('.header-search').removeClass('active');
			}
        });
    }
    if (SitePreferences.PROMOTED_SEARCHES || SitePreferences.SEARCH_SUGGESTIONS_ENABLED || (SitePreferences.CIMULATE_ENABLED && SitePreferences.CIMULATE_SEARCH_SUGGESTIONS_ENABLED)) {
        $(document).on('mouseleave', '.search-suggestions-container, .header-search [name="q"]', function(e) {
            var searchHeader = document.querySelector('.header-search');
            if (!searchHeader.contains(e.relatedTarget) && $('.search-suggestions-container').find(e.relatedTarget).length < 1) {
                $('.search-suggestions-container').hide();
            }
        });

        $(document).on('click', '.close-search-suggestions', function() {
            $('.search-suggestions-container').hide();
        });  
        
        $(document).off('SearchBar.Expand').on('SearchBar.Expand', function() {
            expand();
        });

        $(document).off('SearchBar.ScrollTop').on('SearchBar.ScrollTop', function() {
            scrollTop();
        });

        $(document).off('SearchBar.Hide').on('SearchBar.Hide', function() {
            hide();
        });
    }
}

/**
 * @function
 * @description
 */
function expand() {
    $('.top-banner').toggleClass('search-enabled');
    var $target = $('.header-search');
    if (siteName == SiteConstants.SiteIds.CountryOutfittersUS) {
        $target = $('.search-holder');
    }
            
    if ((siteName == SiteConstants.SiteIds.SheplersUS || siteName == SiteConstants.SiteIds.CountryOutfittersUS) && $('html').hasClass('size-mobile')) {
        $target.css('top', $('.top-banner-bar').outerHeight() + $('.top-banner-inner').outerHeight() - $win.scrollTop());
    } else {
        $target.css('top', '');
    }
            
    if (siteName == SiteConstants.SiteIds.SheplersUS) {
        $target.find('input[type="text"]').focus();
    }
            
    if ($('.top-banner').hasClass('search-enabled') && $('html').hasClass('size-mobile') && $('.top-banner-bar').attr('data-header-for') == 'bootbarn_us') {
        $('#search #q').focus();
    }
}

/**
 * @function
 * @description
 */
function scrollTop() {
    if (siteName == SiteConstants.SiteIds.SheplersUS || siteName == SiteConstants.SiteIds.CountryOutfittersUS) {
        var $target = $('.header-search');
        if (siteName == SiteConstants.SiteIds.CountryOutfittersUS) {
            $target = $('.search-holder');
        }
        
        if ($('html').hasClass('size-mobile')) {
            $target.css('top', $('.top-banner-bar').outerHeight() + $('.top-banner-inner').outerHeight() - $win.scrollTop());
        } else {
            $target.css('top', '');
        }
    }
}

/**
 * @function
 * @description
 */
function hide() {
    if($('.header-search').hasClass('show')) {
        $('.header-search').removeClass('show');
        if (siteName != SiteConstants.SiteIds.BootBarnRspUS) {
            $('.top-banner').removeClass('search-enabled');
        }
    }
}

/**
 * @function
 * @description trigger promoted suggestions for site search
 */
function promotedSuggestions() {
	if (getSuggestionsHttpRequest && getSuggestionsHttpRequest.readyState != 4) { 
		getSuggestionsHttpRequest.abort();
	}
	if (getSuggestionsTimer) {
		clearTimeout(getSuggestionsTimer);
	}

	var $container = $('.search-suggestions-container');
	var $suggestionsContentSlot = $container.find('.html-slot-container');
    var isContentPopulated = $suggestionsContentSlot.length > 0;
    if (isContentPopulated) {
		if ($suggestionsContentSlot.is(':hidden')) {
			$suggestionsContentSlot.show();
		}
		var $suggestions = $container.find('.search-suggestion-wrapper');
		if ($suggestions.is(':visible')) {
			$suggestions.hide();
		}
		if ($container.is(':hidden')) {
        	$container.show();
		}		
    } else if ($container.is(':visible')) {
		$container.hide();
	}
}

function getSuggestions(query) {
	return new Promise(function(resolve, reject) {
		if (getSuggestionsHttpRequest && getSuggestionsHttpRequest.readyState != 4) { 
			getSuggestionsHttpRequest.abort();
		}

		if (query) {
			getSuggestionsLastQuery = query;
			getSuggestionsHttpRequest = $.ajax({
				url: util.appendParamToURL(Urls.searchsuggest, 'q', query),
				type: 'GET',
				success: function(html) {
					if (html) {
						resolve(html);
					} else {
						reject();	
					}
				},
				error: function() {
					reject();
				}
			});
		} else {
			reject();
		}
	});
}

function renderSuggestions(html) {
	return new Promise(function(resolve, reject) {
		var $suggestions;
		var $container = $('.search-suggestions-container');
		if ($container.length > 0) {
			if (html) {
				$suggestions = $container.find('.search-suggestion-wrapper');
				if ($suggestions.length > 0) {
					$suggestions[0].outerHTML = html;
				} else {
					$container.append(html);
				}
			}
			$suggestions = $container.find('.search-suggestion-wrapper');
			if ($suggestions.length > 0) {
				var $suggestionsContentSlot = $container.find('.html-slot-container');
				if ($suggestionsContentSlot.is(':visible')) {
					$suggestionsContentSlot.hide();
				}	
				if ($suggestions.is(':hidden')) {
					$suggestions.show();
				}
				if ($container.is(':hidden')) {
					$container.show();
				}

				resolve();
			} else {
				reject();
			}
		}
	});
}

exports.init = init;